var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_setting",
    "data-name": "vuesax/bold/setting",
    transform: "translate(-236 -190)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.11,3.418,10.94.428a3.857,3.857,0,0,0-3.53,0L2.19,3.438C.12,4.838,0,5.047,0,7.277v5.43c0,2.23.12,2.45,2.23,3.87l5.17,2.99A3.6,3.6,0,0,0,9.17,20a3.531,3.531,0,0,0,1.76-.43l5.22-3.01c2.07-1.4,2.19-1.61,2.19-3.84V7.277C18.34,5.047,18.22,4.838,16.11,3.418Zm-6.94,9.83A3.25,3.25,0,1,1,12.42,10,3.256,3.256,0,0,1,9.17,13.247Z",
    transform: "translate(238.83 192.003)",
    fill: "#a5a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(260 214) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.518e75596d7f64f22e38e1743959750d.svg";
export { ForwardRef as ReactComponent };